<template>
  <page>
    <div class="shadow-1" style="width: 500px;">
      <v-header :title="$t('authentication code')" icon="lock open"></v-header>
      <card footer-color="secondary" style="max-width: 500px">

        <alert :trigger="sendCode"
               color="positive"
               :html="$t('a new code was sent to your email')"></alert>

        <alert :trigger="invalidCode"
               color="negative"
               icon="error"
               :html="$t('invalid code')"></alert>
        <transition name="page" mode="out-in">
          <template>
            <form class="gutter-xs q-pt-xs" @submit.prevent="validateCode">

              <v-input path="code"
                       v-model="form.code"
                       :label="$t('code')"
                       color="highlight"
                       :form="form"
                        style="width: 100%">
              </v-input>

              <div class="row justify-center q-mt-md">
                <v-button outline
                          :disabled="!canValidateCode"
                          :label="$t('validate code')"
                          color="highlight"
                          class="no-shadow uppercase q-btn-iqos"
                          @click="validateCode()">
                </v-button>
                <v-button outline
                          :disabled="!canAskForCode"
                          style="margin-right: 5px"
                          :label="newCodeButtonLabel"
                          color="highlight"
                          class="no-shadow uppercase q-btn-iqos"
                          @click="newCode()">
                </v-button>
              </div>
            </form>
            <template slot="actions"></template>
          </template>
        </transition>

      </card>
    </div>

  </page>
</template>

<script>
import Form from 'vform'
import {QSpinnerPuff} from 'quasar-framework'

export default {
  layout: 'basic',

  metaInfo() {
    return {title: this.$t('log in')}
  },

  components: {
    QSpinnerPuff
  },

  data: () => ({
    invalidCode: false,
    sendCode: false,
    canAskForCode: true,
    canValidateCode: true,
    form: new Form({
      code: '',
    }),
  }),

  created() {
    this.newCode()
  },

  computed: {
    newCodeButtonLabel() {
      return this.canAskForCode ? this.$t('new code') : this.$t('wait 15 seconds...')
    }
  },

  methods: {

    newCode() {
      this.sendCode = false
      this.$store.dispatch('auth/twoFANewToken').then(() => {
        this.sendCode = true
      }).catch(() => {
        this.sendCode = false
      })

      this.canAskForCode = false
      setTimeout(() => {
        this.canAskForCode = true
      }, 15000);
    },

    async validateCode() {
      this.invalidCode = false
      this.canValidateCode = false
      this.$store.dispatch('auth/validatetwoFAToken', this.form.code).then((response) => {
        this.$store.dispatch('auth/fetchUser').then(() => {
          response.data.isValid ? this.$router.push({name: 'home'}) : this.invalidCode = true
        })
        this.canValidateCode = true
      }).catch(() => {
        this.canValidateCode = true
      })
    }

  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/2fa/2fa.vue